export default __webpack_public_path__ + "static/media/hc-6.926de9d1.mp4";